import { render } from "./CustomSpinner.vue?vue&type=template&id=3b56a608&scoped=true"
import script from "./CustomSpinner.vue?vue&type=script&lang=js"
export * from "./CustomSpinner.vue?vue&type=script&lang=js"

import "./CustomSpinner.vue?vue&type=style&index=0&id=3b56a608&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b56a608"]])

export default __exports__